import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section>
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('article.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('article.subtitle')}</p>
        </div>

        <div className="mx-auto mt-8 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2">
          {articles.map((article) => (
            <article
              key={article.slug}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="inline-flex w-fit rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-900">
                {article.tag}
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                <Link
                  to={`/articles/${article.slug}/`}
                  className="hover:text-primary-700 transition-colors"
                >
                  {article.title}
                </Link>
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {article.excerpt}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400">{article.updated}</span>
                <Link
                  to={`/articles/${article.slug}/`}
                  className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors"
                >
                  {t('article.readMore')}
                  <i className="ri-arrow-right-line text-sm" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}